import { initMotion } from "./site/motion";
import { initConsent } from "./site/consent";
import { initTracking } from "./site/track";
import { initForm } from "./site/form";
import { initUi } from "./site/ui";

initTracking();
initConsent();
initForm();
const lenis = initUi();
initMotion(lenis);
